/**
 * Upcart helpers:
 * - Show rewards bar only with theme-settings collection products in cart
 * - Eligible badge on those products
 * - When Upcart says milestonesCompleted >= 2: show "Extra … applied" + line prices
 *   reflecting the real checkout total (no guessing from the 40% sale tag)
 */
(function () {
  var cfg = window.HLT_TIERED_REWARDS || {};
  var COLLECTION_HANDLE = cfg.collectionHandle || 'end-summer-sale-26';
  var COLLECTION_TITLE = cfg.collectionTitle || 'End Summer Sale 26';
  var BADGE_TEXT = cfg.badgeText || 'Eligible for this discount';
  var NOTE_PREFIX = cfg.notePrefix || 'For products in collection: ';
  var COLLECTION_URL = cfg.collectionUrl || '/collections/' + COLLECTION_HANDLE;
  var BADGE_CLASS = 'hlt-rewards-eligible-badge';
  var TIER2_BADGE_CLASS = 'hlt-rewards-tier2-badge';
  var NOTE_CLASS = 'hlt-rewards-collection-note';
  var HIDDEN_CLASS = 'hlt-rewards-hidden';
  var STYLE_ID = 'hlt-tiered-rewards-styles';
  var RETRY_MS = [0, 80, 200, 450, 900];

  var eligibleIds = new Set((cfg.productIds || []).map(Number).filter(Boolean));
  var eligibleHandles = new Set((cfg.productHandles || []).map(String).filter(Boolean));
  var idsReady = false;
  var idsPromise = null;
  var lastItems = [];
  var applying = false;
  var retryTimers = [];
  var observer = null;
  var observedRoot = null;

  function root() {
    return window.upcartDocumentOrShadowRoot || document;
  }

  function cssText() {
    return [
      '.' + HIDDEN_CLASS + ' { display: none !important; }',
      '.upcart-public-cart-summary__slide-codes,',
      '.upcart-internal-cart-summary__slide-codes,',
      '.upcart-public-cart-summary__discount-codes,',
      '.upcart-internal-cart-summary__discount-codes {',
      '  display: none !important;',
      '}',
      '.' + BADGE_CLASS + ',',
      '.' + TIER2_BADGE_CLASS + ' {',
      '  display: block;',
      '  width: fit-content;',
      '  margin-top: 8px;',
      '  padding: 2px 8px;',
      '  font-size: 11px;',
      '  font-weight: 600;',
      '  letter-spacing: 0.02em;',
      '  line-height: 1.3;',
      '  text-transform: uppercase;',
      '  color: #1a1a1a;',
      '  background: #f3e8d8;',
      '  border-radius: 2px;',
      '}',
      '.' + TIER2_BADGE_CLASS + ' { margin-top: 4px; }',
      '.hlt-rewards-price-compare {',
      '  display: inline-block;',
      '  margin-right: 6px;',
      '  text-decoration: line-through;',
      '  opacity: 0.65;',
      '}',
      '.' + NOTE_CLASS + ' {',
      '  display: flex;',
      '  justify-content: center;',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  margin: 12px 0 8px;',
      '  padding: 0;',
      '  background: transparent;',
      '}',
      '.' + NOTE_CLASS + ' a {',
      '  display: inline-block;',
      '  padding: 2px 8px;',
      '  font-size: 11px;',
      '  font-weight: 600;',
      '  letter-spacing: 0.02em;',
      '  line-height: 1.3;',
      '  text-transform: uppercase;',
      '  text-decoration: none;',
      '  color: #1a1a1a;',
      '  background: #f3e8d8;',
      '  border-radius: 2px;',
      '  cursor: pointer;',
      '}',
      '.' + NOTE_CLASS + ' a .hlt-rewards-collection-name { text-decoration: underline; }',
      '.' + HIDDEN_CLASS + ' + .' + NOTE_CLASS + ',',
      '.' + HIDDEN_CLASS + ' .' + NOTE_CLASS + ' { display: none !important; }',
    ].join('\n');
  }

  function ensureStyles() {
    var css = cssText();
    var targets = [document];
    var r = root();
    if (r && r !== document) targets.push(r);

    targets.forEach(function (ctx) {
      var host = (ctx && ctx.head) || ctx;
      if (!host || !host.appendChild) return;
      var style = host.querySelector('#' + STYLE_ID);
      if (!style) {
        style = document.createElement('style');
        style.id = STYLE_ID;
        host.appendChild(style);
      }
      style.textContent = css;
    });
  }

  function hideDiscountChips() {
    root()
      .querySelectorAll(
        '.upcart-public-cart-summary__slide-codes, .upcart-internal-cart-summary__slide-codes, .upcart-public-cart-summary__discount-codes, .upcart-internal-cart-summary__discount-codes'
      )
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
  }

  /** ONLY trust Upcart milestone state — never the 40% sale tag. */
  function isTier2Complete() {
    var rewards = root().querySelector('.upcart-public-rewards, .upcart-rewards');
    if (!rewards) return false;
    var props = rewards.getAttribute('data-internal-properties') || '';
    var match = props.match(/milestonesCompleted=(\d+)/);
    return !!(match && Number(match[1]) >= 2);
  }

  function tier2BadgeText() {
    var labels = root().querySelectorAll(
      '.upcart-public-component-segmented-progress-bar__milestone-label'
    );
    var label = labels[1] && labels[1].textContent ? labels[1].textContent.trim() : '';
    if (label) return label + ' applied';
    return 'Extra 10% OFF applied';
  }

  function loadEligibleProducts() {
    if (idsReady) return Promise.resolve();
    if (idsPromise) return idsPromise;

    idsPromise = (async function () {
      var page = 1;
      while (page <= 10) {
        var res = await fetch(
          '/collections/' + encodeURIComponent(COLLECTION_HANDLE) + '/products.json?limit=250&page=' + page
        );
        if (!res.ok) break;
        var data = await res.json();
        var products = data.products || [];
        if (!products.length) break;
        products.forEach(function (p) {
          if (p.id != null) eligibleIds.add(Number(p.id));
          if (p.handle) eligibleHandles.add(String(p.handle));
        });
        if (products.length < 250) break;
        page += 1;
      }
      idsReady = true;
    })().catch(function () {
      idsReady = true;
    });

    return idsPromise;
  }

  function itemProductId(item) {
    return item && (item.product_id != null ? item.product_id : item.productId);
  }

  function itemHandle(item) {
    return item && item.handle ? String(item.handle) : '';
  }

  function isEligibleItem(item) {
    var id = itemProductId(item);
    if (id != null && eligibleIds.has(Number(id))) return true;
    var handle = itemHandle(item);
    return handle ? eligibleHandles.has(handle) : false;
  }

  function isEligibleHandle(handle) {
    return !!(handle && eligibleHandles.has(handle));
  }

  function cartHasEligible(items) {
    if (!items || !items.length) return false;
    for (var i = 0; i < items.length; i++) {
      if (isEligibleItem(items[i])) return true;
    }
    return false;
  }

  function rewardsNodes() {
    return root().querySelectorAll('.upcart-public-rewards, .upcart-rewards');
  }

  function isFreeGiftTile(tile) {
    var title = tile.querySelector('.upcart-public-component-product-tile__product-title');
    var titleText = ((title && title.textContent) || '').trim();
    if (/FREE/i.test(titleText)) return true;
    var price = tile.querySelector('.upcart-public-component-product-tile__price');
    var priceText = ((price && price.textContent) || '').replace(/\s/g, '');
    return /^\$?0+(\.0+)?$/.test(priceText);
  }

  function parseMoney(text) {
    if (!text) return NaN;
    return parseFloat(String(text).replace(/[^0-9.]/g, ''));
  }

  function formatMoney(amount) {
    return '$' + (Math.round(amount * 100) / 100).toFixed(2);
  }

  function getCheckoutTotalDollars() {
    var btn = root().querySelector('.upcart-checkout-button');
    if (!btn) return null;
    var m = (btn.textContent || '').match(/\$[\d,]+\.?\d*/);
    return m ? parseMoney(m[0]) : null;
  }

  /** Factor from real checkout ÷ paid line totals (e.g. 0.9). Null if not discounted yet. */
  function getOrderDiscountFactor() {
    if (!isTier2Complete()) return null;

    var lines = 0;
    root().querySelectorAll('.upcart-public-cart-item').forEach(function (tile) {
      if (isFreeGiftTile(tile)) return;
      var priceEl = tile.querySelector('.upcart-public-component-product-tile__price');
      if (!priceEl) return;
      var base = priceEl.dataset.hltSalePrice
        ? parseFloat(priceEl.dataset.hltSalePrice)
        : parseMoney(priceEl.textContent);
      if (base > 0) lines += base;
    });

    var checkout = getCheckoutTotalDollars();
    if (!checkout || !lines || checkout >= lines - 0.009) return null;
    return checkout / lines;
  }

  function paintTier2Price(tile, factor) {
    var priceEl = tile.querySelector('.upcart-public-component-product-tile__price');
    if (!priceEl) return;
    var group =
      priceEl.closest('.upcart-public-component-product-tile__price-group') || priceEl.parentElement;
    if (!group) return;
    var compare = group.querySelector('.hlt-rewards-price-compare');

    if (!factor) {
      if (priceEl.dataset.hltSalePrice) {
        priceEl.textContent = formatMoney(parseFloat(priceEl.dataset.hltSalePrice));
        delete priceEl.dataset.hltSalePrice;
        delete priceEl.dataset.hltTier2Painted;
      }
      if (compare) compare.remove();
      return;
    }

    var base = priceEl.dataset.hltSalePrice
      ? parseFloat(priceEl.dataset.hltSalePrice)
      : parseMoney(priceEl.textContent);
    if (!base || base <= 0) return;

    priceEl.dataset.hltSalePrice = String(base);
    priceEl.dataset.hltTier2Painted = '1';
    priceEl.textContent = formatMoney(base * factor);

    if (!compare) {
      compare = document.createElement('span');
      compare.className = 'hlt-rewards-price-compare';
      group.insertBefore(compare, priceEl);
    }
    compare.textContent = formatMoney(base);
  }

  function injectCollectionNote(rewardsEl, visible) {
    var parent = rewardsEl.parentNode;
    if (!parent) return;

    var existing = null;
    var prev = rewardsEl.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains(NOTE_CLASS)) existing = prev;
    else existing = parent.querySelector('.' + NOTE_CLASS);

    if (!visible) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('p');
      existing.className = NOTE_CLASS;
    }
    parent.insertBefore(existing, rewardsEl);
    if (existing.querySelector('a')) return;

    var link = document.createElement('a');
    link.href = COLLECTION_URL;
    link.setAttribute('aria-label', NOTE_PREFIX + COLLECTION_TITLE);
    link.appendChild(document.createTextNode(NOTE_PREFIX));
    var name = document.createElement('span');
    name.className = 'hlt-rewards-collection-name';
    name.textContent = COLLECTION_TITLE;
    link.appendChild(name);
    existing.appendChild(link);
  }

  function setRewardsVisible(visible) {
    ensureStyles();
    rewardsNodes().forEach(function (el) {
      if (visible) el.classList.remove(HIDDEN_CLASS);
      else el.classList.add(HIDDEN_CLASS);
      injectCollectionNote(el, visible);
    });
  }

  function handleFromHref(href) {
    if (!href) return '';
    try {
      var path = href.indexOf('http') === 0 ? new URL(href).pathname : href;
      var parts = path.split('/products/');
      if (parts.length < 2) return '';
      return decodeURIComponent(parts[1].split(/[?#]/)[0]).replace(/\/$/, '');
    } catch (e) {
      return '';
    }
  }

  function placeAfterControls(tile, el) {
    var controls =
      tile.querySelector('.upcart-public-component-product-tile__controls') ||
      tile.querySelector('.upcart-public-component-product-tile__quantity-selector');
    var anchor =
      (controls && controls.parentElement) ||
      tile.querySelector('.upcart-public-component-product-tile__info') ||
      tile;

    if (controls && controls.parentElement === anchor) {
      if (controls.nextSibling) anchor.insertBefore(el, controls.nextSibling);
      else anchor.appendChild(el);
    } else {
      anchor.appendChild(el);
    }
  }

  function ensureBadge(tile, className, text) {
    var existing = tile.querySelector('.' + className);
    if (existing) {
      existing.textContent = text;
      return existing;
    }
    var el = document.createElement('span');
    el.className = className;
    el.textContent = text;
    placeAfterControls(tile, el);
    return el;
  }

  function injectBadges(items) {
    if (applying) return;
    applying = true;

    try {
      ensureStyles();
      hideDiscountChips();

      var tiles = root().querySelectorAll('.upcart-public-cart-item');
      if (!tiles.length) return;

      var byHandle = {};
      (items || []).forEach(function (item) {
        var h = itemHandle(item);
        if (h) byHandle[h] = item;
      });

      var tier2 = isTier2Complete();
      var factor = tier2 ? getOrderDiscountFactor() : null;
      var t2Text = tier2 ? tier2BadgeText() : '';

      tiles.forEach(function (tile, index) {
        var link = tile.querySelector(
          '.upcart-public-component-product-tile__title-link, a[href*="/products/"]'
        );
        var handle = handleFromHref(link && (link.getAttribute('href') || link.href));
        var item = (handle && byHandle[handle]) || (items && items[index]) || null;
        var eligible = item ? isEligibleItem(item) : isEligibleHandle(handle);
        var freeGift = isFreeGiftTile(tile);
        var paid = !freeGift;

        var eligibleBadge = tile.querySelector('.' + BADGE_CLASS);
        var tier2Badge = tile.querySelector('.' + TIER2_BADGE_CLASS);

        if (eligible && paid) ensureBadge(tile, BADGE_CLASS, BADGE_TEXT);
        else if (eligibleBadge) eligibleBadge.remove();

        // Tier 2 UI only when Upcart milestone 2 is complete
        if (paid && tier2) {
          ensureBadge(tile, TIER2_BADGE_CLASS, t2Text);
          paintTier2Price(tile, factor);
        } else {
          if (tier2Badge) tier2Badge.remove();
          paintTier2Price(tile, null);
        }
      });
    } finally {
      applying = false;
    }
  }

  function sync(cart) {
    var items = (cart && cart.items) || lastItems || [];
    lastItems = items;
    setRewardsVisible(cartHasEligible(items));
    injectBadges(items);
    ensureObserver();
  }

  function fetchShopifyCart() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function clearRetryTimers() {
    retryTimers.forEach(clearTimeout);
    retryTimers = [];
  }

  function scheduleSync(event) {
    loadEligibleProducts().then(function () {
      var upcartCart = (event && event.cart) || (window.upcartGetCart && window.upcartGetCart()) || null;
      fetchShopifyCart().then(function (shopifyCart) {
        sync(shopifyCart || upcartCart || { items: lastItems });
      });

      clearRetryTimers();
      RETRY_MS.forEach(function (ms) {
        if (!ms) return;
        retryTimers.push(
          setTimeout(function () {
            fetchShopifyCart().then(function (shopifyCart) {
              var upcartCart = window.upcartGetCart && window.upcartGetCart();
              sync(shopifyCart || upcartCart || { items: lastItems });
            });
          }, ms)
        );
      });
    });
  }

  function ensureObserver() {
    var r = root();
    var target = r.querySelector('#CartPopup, .upcart-cart, .upcart-public-cart-items') || r;
    if (!target || target === observedRoot) return;

    if (observer) observer.disconnect();
    observedRoot = target;

    observer = new MutationObserver(function () {
      if (applying) return;
      clearRetryTimers();
      retryTimers.push(
        setTimeout(function () {
          scheduleSync({});
        }, 80)
      );
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function bindUpcart() {
    if (typeof window.upcartSubscribeCartLoaded !== 'function') return false;

    window.upcartSubscribeCartLoaded(scheduleSync);
    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      window.upcartSubscribeCartUpdated(scheduleSync);
    }
    if (typeof window.upcartSubscribeAddedToCart === 'function') {
      window.upcartSubscribeAddedToCart(function () {
        scheduleSync({ cart: window.upcartGetCart && window.upcartGetCart() });
      });
    }
    if (typeof window.upcartSubscribeCartOpened === 'function') {
      window.upcartSubscribeCartOpened(function () {
        setTimeout(function () {
          scheduleSync({ cart: window.upcartGetCart && window.upcartGetCart() });
        }, 300);
      });
    }
    if (typeof window.upcartSubscribeRewardsMilestonesCompletedChanged === 'function') {
      window.upcartSubscribeRewardsMilestonesCompletedChanged(function () {
        scheduleSync({ cart: window.upcartGetCart && window.upcartGetCart() });
      });
    }

    setRewardsVisible(false);
    loadEligibleProducts();
    ensureObserver();
    return true;
  }

  function waitForUpcart() {
    if (bindUpcart()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (bindUpcart() || tries > 100) clearInterval(timer);
    }, 150);
  }

  waitForUpcart();
})();
